module.exports = __webpack_public_path__ + "img/inventory-screen.56211e67.svg";